import { getAuthRole, getAuthUserId } from "./authSession";

export const DOCUMENT_TEMPLATE_MANAGER_IDS = [
  "1daa441a-99b6-4752-b9e7-f189b6f8dc17",
  "2301ab0e-a588-40b5-8e77-3e0b31de865c",
];

export function canManageDocumentTemplates() {
  const role = getAuthRole();
  if (role === "admin") return true;
  const userId =
    getAuthUserId() || String(localStorage.getItem("user_id") || "").trim();
  return DOCUMENT_TEMPLATE_MANAGER_IDS.includes(userId);
}
